module.exports = __webpack_public_path__ + "img/Exterior_03.1fd888dd.png";